import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", fillRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2, clipRule: "evenodd", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "m14.4 11.75-4.37-4.36-.53.53 4.1 4.1-4.07 4.06.53.53 4.33-4.33a.37.37 0 0 0 0-.53Z" }));
const ForwardRef = forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
